/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, */

// provides the base for iphones

_.namespace(`mp.marketing.trends.utils`, function(ns) {
  'use strict';
  // iPhone model id information can be found at:
  // https://www.theiphonewiki.com/wiki/Models
  // OR
  // https://en.wikipedia.org/wiki/List_of_iOS_devices
  // Please keep sorted in reverse chronological order
  ns.OTHER_IPHONE = {
    name: `Other`,
    regex: /^iPhone[0-9]+,\d$/,
  };
  ns.IPHONE_12_PRO_MAX = {
    name: `iPhone 12 Pro Max`,
    release_date: Date.parse(`12 Nov 2020 16:00:00`).setTimezone(`PST`),
    regex: /^iPhone13,(4)$/,
  };
  ns.IPHONE_12_PRO = {
    name: `iPhone 12 Pro`,
    release_date: Date.parse(`22 Oct 2020 16:00:00`).setTimezone(`PST`),
    regex: /^iPhone13,(3)$/,
  };
  ns.IPHONE_12 = {
    name: `iPhone 12`,
    release_date: Date.parse(`22 Oct 2020 16:00:00`).setTimezone(`PST`),
    regex: /^iPhone13,(2)$/,
  };
  ns.IPHONE_12_MINI = {
    name: `iPhone 12 Mini`,
    release_date: Date.parse(`12 Nov 2020 16:00:00`).setTimezone(`PST`),
    regex: /^iPhone13,(1)$/,
  };
  ns.IPHONE_SE_2ND_GEN = {
    name: `iPhone SE Second Gen`,
    release_date: Date.parse(`16 Apr 2020 16:00:00`).setTimezone(`PST`),
    regex: /^iPhone12,(8)$/,
  };
  ns.IPHONE_11_PRO_MAX = {
    name: `iPhone 11 Pro Max`,
    release_date: Date.parse(`20 Sep 2019 16:00:00`).setTimezone(`PST`),
    regex: /^iPhone12,(5)$/,
  };
  ns.IPHONE_11_PRO = {
    name: `iPhone 11 Pro`,
    release_date: Date.parse(`20 Sep 2019 16:00:00`).setTimezone(`PST`),
    regex: /^iPhone12,(3)$/,
  };
  ns.IPHONE_11 = {
    name: `iPhone 11`,
    release_date: Date.parse(`20 Sep 2019 16:00:00`).setTimezone(`PST`),
    regex: /^iPhone12,(1)$/,
  };
  ns.IPHONE_XR = {
    name: `iPhone XR`,
    release_date: Date.parse(`26 Oct 2018 16:00:00`).setTimezone(`PST`),
    regex: /^iPhone11,(8)$/,
  };
  ns.IPHONE_XS = {
    name: `iPhone XS`,
    release_date: Date.parse(`21 Sep 2018 16:00:00`).setTimezone(`PST`),
    regex: /^iPhone11,(2)$/,
  };
  ns.IPHONE_XS_MAX = {
    name: `iPhone XS Max`,
    release_date: Date.parse(`21 Sep 2018 16:00:00`).setTimezone(`PST`),
    regex: /^iPhone11,(4|6)$/,
  };
  ns.IPHONE_X = {
    name: `iPhone X`,
    release_date: Date.parse(`2 Nov 2017 16:00:00`).setTimezone(`PST`),
    regex: /^iPhone10,(3|6)$/,
  };
  ns.IPHONE_8 = {
    name: `iPhone 8`,
    release_date: Date.parse(`21 Sep 2017 16:00:00`).setTimezone(`PST`),
    regex: /^iPhone10,(1|4)$/,
  };
  ns.IPHONE_8_PLUS = {
    name: `iPhone 8 Plus`,
    release_date: Date.parse(`21 Sep 2017 16:00:00`).setTimezone(`PST`),
    regex: /^iPhone10,(2|5)$/,
  };
  ns.IPHONE_7 = {
    name: `iPhone 7`,
    release_date: Date.parse(`16 Sep 2016 16:00:00`).setTimezone(`PST`),
    regex: /^iPhone9,(1|3)$/,
  };
  ns.IPHONE_7_PLUS = {
    name: `iPhone 7 Plus`,
    release_date: Date.parse(`16 Sep 2016 16:00:00`).setTimezone(`PST`),
    regex: /^iPhone9,(2|4)$/,
  };
  ns.IPHONE_SE = {
    name: `iPhone SE`,
    release_date: Date.parse(`31 Mar 2016 16:00:00`).setTimezone(`PST`),
    regex: /^iPhone8,(4)$/,
  };
  ns.IPHONE_6S_PLUS = {
    name: `iPhone 6s Plus`,
    release_date: Date.parse(`25 Sep 2015 16:00:00`).setTimezone(`PST`),
    regex: /^iPhone8,(2)$/,
  };
  ns.IPHONE_6S = {
    name: `iPhone 6s`,
    release_date: Date.parse(`25 Sep 2015 16:00:00`).setTimezone(`PST`),
    regex: /^iPhone8,(1)$/,
  };
  ns.IPHONE_6_PLUS = {
    name: `iPhone 6 Plus`,
    release_date: Date.parse(`19 Sep 2014 16:00:00`).setTimezone(`PST`),
    regex: /^iPhone7,(1)$/,
  };
  ns.IPHONE_6 = {
    name: `iPhone 6`,
    release_date: Date.parse(`19 Sep 2014 16:00:00`).setTimezone(`PST`),
    regex: /^iPhone7,(2)$/,
  };
  ns.IPHONE_5S = {
    name: `iPhone 5s`,
    release_date: Date.parse(`20 Sep 2013 16:00:00`).setTimezone(`PST`),
    regex: /^iPhone6,(1|2)$/,
  };
  ns.IPHONE_5C = {
    name: `iPhone 5c`,
    release_date: Date.parse(`20 Sep 2013 16:00:00`).setTimezone(`PST`),
    regex: /^iPhone5,(3|4)$/,
  };
  ns.IPHONE_5 = {
    name: `iPhone 5`,
    release_date: Date.parse(`21 Sep 2012 16:00:00`).setTimezone(`PST`),
    regex: /^iPhone5,(1|2)$/,
  };
  ns.IPHONE_4S = {
    name: `iPhone 4s`,
    release_date: Date.parse(`14 Oct 2011 16:00:00`).setTimezone(`PST`),
    regex: /^iPhone4,(1)$/,
  };
  ns.IPHONE_4 = {
    name: `iPhone 4`,
    release_date: Date.parse(`24 Jun 2010 16:00:00`).setTimezone(`PST`),
    regex: /^iPhone3,(1|2|3)$/,
  };
  ns.IPHONE_3GS = {
    name: `iPhone 3GS`,
    release_date: Date.parse(`19 Jun 2009 16:00:00`).setTimezone(`PST`),
    regex: /^iPhone2,(1)$/,
  };
  ns.IPHONE_3G = {
    name: `iPhone 3G`,
    release_date: Date.parse(`11 Jul 2008 16:00:00`).setTimezone(`PST`),
    regex: /^iPhone1,(2)$/,
  };
  ns.IPHONE_1 = {
    name: `iPhone 1`,
    release_date: Date.parse(`29 Jul 2007 16:00:00`).setTimezone(`PST`),
    regex: /^iPhone1,(1)$/,
  };
  ns.IPHONE_QUERY = `iphone_models`;
});

}.call(window));